import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-283c6767"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-cards" }
const _hoisted_2 = { class: "card-label" }
const _hoisted_3 = ["src", "onClick"]


import { ElMessageBox } from 'element-plus'
import InfoIcon from '@/assets/images/home/info1.svg'

interface CardItem {
  label: string
  value: string
  showTip?: boolean
  tipContent?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryCards',
  props: {
    cards: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  cards: CardItem[]
  loading?: boolean
};



const getValueFontSize = (value: string) => {
  if (props.cards.length < 4) return '28px'
  const len = (value ?? '').length
  if (len >= 15) return '16px'
  if (len >= 12) return '18px'
  if (len >= 9) return '24px'
  return '28px'
}

const handleTipClick = (card: CardItem) => {
  ElMessageBox.alert(card.tipContent || '', '免责声明', {
    confirmButtonText: '我知道了',
    customClass: 'message-info',
    showClose: false,
    center: true,
    type: ''
  })
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "summary-card-item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(card.label), 1),
          (card.showTip)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(InfoIcon),
                class: "card-tip-icon",
                alt: "info",
                onClick: _withModifiers(($event: any) => (handleTipClick(card)), ["stop"])
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "card-value",
          style: _normalizeStyle({ fontSize: getValueFontSize(card.value) })
        }, _toDisplayString(card.value), 5)
      ]))
    }), 128))
  ])), [
    [_directive_loading, __props.loading]
  ])
}
}

})